import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ContactComponent} from './pages/contact/contact.component';
import { AdventureComponent} from './pages/adventure/adventure.component';
import { from } from 'rxjs';

import {SignComponent} from './pages/sign/sign.component';
import {AdminlandComponent} from './pages/adminland/adminland.component';
import { PageNotFoundComponent } from "./pages/page-not-found/page-not-found.component";

const routes: Routes = [
  { path: "", component: HomeComponent },
  {path: "contact", component: ContactComponent},
  {path: "adventure", component: AdventureComponent},
  {path: "sign", component: SignComponent},
 //{path: "admin", component: AdminlandComponent},

 { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
